import { hasInvalidCharsInAssetName } from 'features/asset';
import { trimFieldValue } from 'ui/forms';

lp.utils = lp.utils || {};

$(() => {

	function checkAssetConflict (data) {

		if (!data) {

			return false;

		}

		const {
			ErrorMessage, ErrorMessages, forceAssetPrompt, OperationResponse
		} = data;

		// all these responses throw asset conflict
		return (
			(ErrorMessage && (ErrorMessage === 'Conflict' || ErrorMessage === 'FailureNameAlreadyExists'))
			|| (ErrorMessages && ErrorMessages.indexOf('Conflict') >= 0)
			|| forceAssetPrompt
			|| (OperationResponse
				&& OperationResponse.ErrorMessages
				&& OperationResponse.ErrorMessages.indexOf('Conflict') >= 0)
			|| (OperationResponse && OperationResponse.Status === 28)
		);

	}

	lp.utils.showAssetPrompt = function (options) {

		const app = new Backbone.Marionette.Application();
		const width = 450;
		const height = 180;
		const openFunc = function (options) {

			let validator;
			let assetPromptView;
			const AssetPromptView = Marionette.ItemView.extend({
				template: '/shared/templates/asset-prompt',
				ui: {
					showReplace: '.showReplace',
					showCreate: '.showCreate',
					assetName: '.assetName',
					btnRenameAsset: '.btnRenameAsset',
					btnRenameAssetToggle: '.btnRenameAssetToggle',
					lnkOverwriteAsset: '.lnkOverwriteAsset',
					lnkCancelAssetConflict: '.lnkCancelAssetConflict',
					lnkCancelAssetRename: '.lnkCancelAssetRename',
					form: '#assetRenamePrompt'
				},
				events: {
					'click @ui.btnRenameAssetToggle': 'showCreateForm',
					'click @ui.btnRenameAsset': 'renameAsset',
					'click @ui.lnkOverwriteAsset': 'overwriteAsset',
					'click @ui.lnkCancelAssetConflict': 'cancelConflict',
					'click @ui.lnkCancelAssetRename': 'showConflictForm',
					'input @ui.assetName': 'handleAssetNameInput',
					'keypress @ui.assetName': 'handleAssetNameKeypress'
				},
				templateHelpers () {

					return {
						typeName () {

							return this.assetType === 'scene' ? 'room' : this.assetType;

						}
					};

				},
				/** close modal window */
				_closeModalWindow () {

					if (options.iframe) {

						window.parent.$('#lpModalClose').trigger('click');

					} else {

						$('#lpModalClose').trigger('click');

					}

				},
				initAssetRenamePromptStyle (assetRenamePrompt) {

					const styleEle = document.createElement('style');
					styleEle.innerHTML = `.promptModal #assetRenamePrompt {
							padding: 0;
						}

						#assetRenamePrompt {
							margin-top: 0;
							padding: 0 20px;
						}
						#assetRenamePrompt .showCreate {
							display: none;
						}

						#assetRenamePrompt h2 {
							font-size: 1.45rem;
							font-weight: 500;
						}

						#assetRenamePrompt .assetType.capitalize {
							text-transform: capitalize;
						}

						#assetRenamePrompt .assetName {
							box-sizing: border-box;
							height: 33px;
							padding: 5px;
							width: 100%;
						}

						#assetRenamePrompt .actionButtons {
							float: right;
							margin-top: 20px;
						}

						#assetRenamePrompt button.actionButton {
							margin-top: 0;
						}

						#assetRenamePrompt .actionButton {
							margin-left: 20px;
						}

						#assetRenamePrompt .actionButton &:first-child{
							margin-left: 0;
						}

						#assetRenamePrompt .accountValidation {
							left: 0;
							top: 55px;
						}

						#assetRenamePrompt .accountValidation .error {
							left: 0;
							margin-left: 0;
							top: -22px;
						}

						#assetRenamePrompt .modalCopy {
							margin-top: 10px;
						}

						#assetRenamePrompt .buttons {
							bottom: 32px;
							position: absolute;
							right: 35px;
						}

						#assetRenamePrompt .buttons a {
							margin-left: 18px;
						}

						#assetRenamePrompt .buttons a &:first-child {
							margin-left: 0;
						}

						#assetRenamePrompt dd {
							padding: 0;
						}
						`;

					if (assetRenamePrompt) {

						assetRenamePrompt.appendChild(styleEle);

					}

				},
				onShow () {

					const that = this;

					that.initAssetRenamePromptStyle(document.querySelector('#assetRenamePrompt'));

					const validationOptions = {
						rules: {
							SceneName: {
								required: true,
								remote: {
									url: options.url,
									dataType: options.dataType || 'json',
									type: options.type || 'post',
									data: options.data,
									complete (response, textStatus) {

										let data;

										if (response.responseJSON) {

											data = response.responseJSON;

										} else {

											try {

												data = JSON.parse(response.responseText);

											} catch (e) {

												console.warn(e);

											}

										}

										if (data && textStatus === 'success') {

											// if conflict exists
											if (checkAssetConflict(data)) {

												const error = {};
												const element = that.ui.assetName[0];
												const previous = validator.previousValue(element);

												error[element.name] =													validator.settings.messages[element.name].nameExists;
												validator.invalid[element.name] = true;
												validator.showErrors(error);
												previous.valid = false;
												validator.stopRequest(element, false);
												$(lp).trigger('renameAssetConflict');

											} else {

												$(lp).trigger('renameAssetSuccess');

												if (options.assetType === 'scene') {

													options.success({
														token: data.Token || null,
														name: that.ui.assetName[0].value
													});

												} else if (options.assetType === 'wish list') {

													options.success({ name: that.ui.assetName[0].value });

												} else if (options.assetType === 'project') {

													options.success({
														name: data.ProjectName,
														timeStamp: data.OperationResponse.Timestamp,
														status: data.OperationResponse.Status,
														id: data.OperationResponse.ProjectId
													});

												} else {

													options.success();

												}

											}

										} else if (textStatus === 'error') {

											const error = {};
											const element = that.ui.assetName[0];
											const previous = validator.previousValue(element);

											error[element.name] = validator.settings.messages[element.name].remote;
											validator.invalid[element.name] = true;
											validator.showErrors(error);
											previous.valid = false;
											validator.stopRequest(element, false);
											$(lp).trigger('renameAssetError');

										}

									}
								}
							}
						},
						messages: {
							AssetName: {
								remote: "Sorry, we've encountered an error! Please try your request again.",
								nameExists: `The ${options.assetType} name you entered already exists`
							}
						},
						onkeyup (element) {

							if (element.value) {

								validator.resetForm();
								$(element).css({
									border: '1px solid #adadad'
								});
								return false;

							}
							return $(element).valid();

						},
						onfocusout (element) {

							trimFieldValue(element);
							if (element.value) {

								validator.resetForm();
								$(element).css({
									border: '1px solid #adadad'
								});
								return false;

							}
							return $(element).valid();

						}
					}; // validationOptions

					validator = window.initFormValidation(false, this.ui.form, validationOptions);

				},
				cancelConflict (e) {

					e.preventDefault();
					this._closeModalWindow();

				},
				showConflictForm (e) {

					e.preventDefault();
					$(this.ui.assetName).blur();
					$(this.ui.showCreate).hide();
					$(this.ui.showReplace).show();

				},
				showCreateForm (e) {

					e.preventDefault();
					$(this.ui.showReplace).hide();
					$(this.ui.showCreate).show();
					$(this.ui.assetName).select().focus();

				},
				renameAsset (e) {

					e.preventDefault();

					const element = this.ui.assetName[0];
					const { data } = validator.settings.rules[element.name].remote;
					data.SceneName =						(validator.currentForm
							&& validator.currentForm.SceneName
							&& validator.currentForm.SceneName.value)
						|| '';

					if (data === undefined) {

						validator.settings.rules[element.name].remote.data = {};

					}

					if (typeof data === 'string') {

						validator.settings.rules[element.name].remote.data = JSON.parse(data);

					}
					validator.settings.rules[element.name].remote.data[options.attributeName] = element.value;
					this.ui.assetName.valid();

				},
				overwriteAsset (e) {

					const that = this;

					e.preventDefault();

					// parse data
					if (typeof options.data === 'string') {

						options.data = JSON.parse(options.data);

					} else if (options.data === undefined) {

						options.data = {};

					}

					// set flag to overwrite asset
					options.data.Overwrite = true;

					$.ajax({
						url: options.url,
						type: options.type || 'post',
						data: options.data,
						success (data) {

							if (options.assetType === 'scene') {

								options.success({ token: options.data.Token, name: options.data.SceneName });

							} else if (options.assetType === 'wish list') {

								const params = { name: data.Name };

								// add ViewType when switching views (Grid, Compare, Detail)
								if (options.url.indexOf('/view') !== -1) {

									params.ViewType = options.data.ViewType;

								}

								options.success(params);

							} else if (options.assetType === 'project') {

								options.success({
									name: data.ProjectName,
									timeStamp: data.OperationResponse.Timestamp,
									status: data.OperationResponse.Status,
									id: data.OperationResponse.ProjectId
								});

							} else {

								options.success();

							}

							that._closeModalWindow();

						},
						error () {

							options.error();

						}
					});

				},
				handleAssetNameKeypress (e) {

					// prevent invalid characters
					if (hasInvalidCharsInAssetName(e.which)) {

						return false;

					}
					return true;

				}
			});

			if (options.iframe) {

				app.addRegions({
					modalContentRegion: options.contentSelector
				});

			} else {

				app.addRegions({
					modalContentRegion: '#lpModalContent'
				});

			}

			app.addInitializer(() => {

				const model = new Backbone.Model({
					assetType: options.assetType,
					assetName: options.assetName,
					actionLink: options.actionLink || 'Use Another Name'
				});

				assetPromptView = new AssetPromptView({ model });
				app.modalContentRegion.show(assetPromptView);

			});

			app.start();

		};

		if (options.iframe) {

			window.parent.$('body').lpModalResize({
				width,
				height
			});

			openFunc(options);

		} else if (options.resize) {

			$('body').lpModalResize({
				width,
				height
			});

			openFunc(options);

		} else {

			$('body').lpModal({
				onInit: true,
				width,
				height,
				appendContentToForm: false,
				content: $(),
				closeEvt: () => {

					if (options.cancel) {

						options.cancel();

					}

				}
			});

			openFunc(options);

		}

		$('#lpModalClose').on('click', () => {

			if (options.cancel) {

				options.cancel();

			}

			app.modalContentRegion.reset();
			app.destroy();

			$('#lpModalClose').off();

		});

	};

	$.ajaxPrefilter((options, originalOptions) => {

		const origSuccess = originalOptions.success;
		const origData = originalOptions.data;
		const origUrl = originalOptions.url;
		const origType = originalOptions.type;

		options.success = function (data) {

			if (checkAssetConflict(data)) {

				const isInModalIframe = window.parent.$('#lpModal').length > 0;
				const checkContentSelector = function () {

					if (!isInModalIframe) {

						return null;

					}

					return `#${$('.promptModal').length > 1 ? $('.promptModal').attr('id') : 'lpModalContent'}`;

				};
				const checkAsset = function () {

					const asset = {
						type: null,
						attributeName: null
					};

					if (origUrl.indexOf('globalprojectplanners') !== -1) {

						asset.type = 'project';
						asset.attributeName = 'ProjectName';

					} else if (origUrl.indexOf('globalwishlists') !== -1) {

						asset.type = 'wish list';
						asset.attributeName = 'Name';

					} else if (origUrl.indexOf('myscenes') !== -1) {

						asset.type = 'scene';
						asset.attributeName = 'SceneName';

					}

					return asset;

				};
				const thisAsset = checkAsset();

				// don't call showAssetPromt again if we already did it
				if ($('#assetRenamePrompt').length) {

					return;

				}

				lp.utils.showAssetPrompt({
					assetType: thisAsset.type,
					// AR uses a different API
					assetName: data.Name || data.SceneName || origData.SceneName,
					type: origType,
					// for AR publish API call we dont send any origData
					data: origData || data,
					url: origUrl,
					attributeName: thisAsset.attributeName,
					iframe: isInModalIframe,
					contentSelector: checkContentSelector(),
					actionLink: data.Name ? 'Use Another Name' : null,
					cancel () {

						if (thisAsset.type === 'wish list') {

							// all these operations can only be done on wishlist page, so no need to do a check on other pages such as PDP, etc.
							if ($('#bdWishlist').length) {

								if (options.url.indexOf('/name') !== -1) {

									$('#wishlistHeader h1').text(options.name).removeClass('contentEditableProcessing');
									$(lp.wishlist).trigger('loadWishListItems', [ $('.wishlistView').attr('id') ]);

								} else if (options.url.indexOf('/quantity') !== -1) {

									// if changing wishlist quantity
									const qtyField = `.wishlistItem-${origUrl.split('/')[4]} input.wishlistQty`;
									$(qtyField).val($(qtyField).data('origValue'));

								} else if (options.url.indexOf('/operation/select') !== -1) {

									// if selecting a wishlist
									const wishlistItem = `.wishlistItem-${origUrl.split('/')[4]}`;
									window.lp.utils.hideStatusIndicator();
									$(wishlistItem).removeClass('deleteInProgress');

								} else if (options.url.indexOf('/view') !== -1) {

									// if switching views (Grid, Compare or Detail)
									window.lp.utils.hideStatusIndicator();

								} else if (origType === 'DELETE') {

									// if deleting a wishlist
									const wishlistItem = `.wishlistItem-${origUrl.split('/')[4]}`;
									window.lp.utils.hideStatusIndicator();
									$(wishlistItem).removeClass('deleteInProgress');
									$(`${wishlistItem} .ctrlRemove`).removeClass('disabled');
									$('#wishlistBody').removeData('currentSlideIndex');

								}

							}

						} else if (thisAsset.type === 'project') {
							// TODO - need to complete this for project planner
						} else if (thisAsset.type === 'scene') {

							Backbone.history.loadUrl();

						}

					},
					success (options) {

						let viewType;
						let callback;
						let windowObj;

						if (thisAsset.type === 'wish list') {

							if ($('#bdWishlist').length) {

								windowObj = isInModalIframe ? window.parent : window;

								windowObj.$('#lpModalClose').trigger('click');
								windowObj.$('#wishlistHeader h1').text(options.name);

								// switching views (Grid, Compare, Detail)
								if (origUrl.indexOf('/view') !== -1) {

									viewType = options.ViewType;
									callback = function () {

										windowObj
											.$('#wishlistHeader .viewType')
											.filter(function () {

												const regex = new RegExp(viewType, 'i');
												return regex.test($(this).data('view'));

											})
											.addClass('selected')
											.siblings()
											.removeClass('selected');

									};

								} else {

									viewType = windowObj.$('.wishlistView').attr('id');

								}

								windowObj.$(lp.wishlist).trigger('loadWishListItems', [ viewType, callback ]);

							} else {

								window.location.href = '/wish-list';

							}

							// } else if (thisAsset.type === 'project') {

							// 	if (options.status === 2) {

							// 		lp.projectPlanner.loadSingleProject(options.id);
							// 		$('#lpModalClose').trigger('click');

							// 	}

						} else if (thisAsset.type === 'scene') {

							// if we already in the AR's viewer then do soft reload otherwise go to AR's viewer page
							if (Backbone.history.location.pathname === '/viewer/') {

								Backbone.history.loadUrl();
								data.IsSuccessful = true;
								origSuccess.call(this, data);

							} else {

								window.parent.location.href = '/viewer/';

							}

							// close modal
							$('#lpModalClose').trigger('click');

						}

					},
					error () {

						// display error in error div, doesn't matter if on wishlist/project/scene page or not
						$('#assetRenamePrompt .error').text('Saving failed.');

					}
				});

			} else if (origSuccess) {

				origSuccess.call(this, data);

			}

		};

	});

});
